import { render, staticRenderFns } from "./GroupTestReportContent.vue?vue&type=template&id=ba4935e6&"
import script from "./GroupTestReportContent.vue?vue&type=script&lang=ts&"
export * from "./GroupTestReportContent.vue?vue&type=script&lang=ts&"
import style0 from "./GroupTestReportContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports